/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
import{legacyIcon as o}from"../support/legacyIcon.js";const c="esri-compass",e={base:c,widgetIcon:o.locateCircled,iconContainer:`${c}__icon-container`};export{e as css};
